<template>
    <div id="order-history">
        <div class="container">
            <template v-if="getOrderHistory">
                <div class="accordian-titles">
                    <span>Order No</span>
                    <span>Date</span>
                    <span>Order Status</span>
                    <span>Order Type</span>
                    <span>Order Total</span>
                </div>

                <div class="accordian-container" v-for="(order, index) in getOrderHistory" :key="'order' + index">
                    <div class="accordian-title" block href="#" v-b-toggle="'accordion' + index" variant="secondary">
                        <div>
                            <span class="mob-title">Order No</span>
                            <span v-if="order.Reference">{{order.Reference}}</span>
                            <span v-else-if="order.ID">{{order.ID}}</span>
                        </div>
                        <div>
                            <span class="mob-title">Date</span>
                            <span>{{order.FormattedPlacedDate}}</span>
                        </div>
                        <div>
                            <span class="mob-title">Order Status</span>
                            <span>{{order.Status}}</span>
                        </div>
                        <div>
                            <span class="mob-title">Order Type</span>
                            <span>{{order.OrderTypeSummary}}</span>
                        </div>
                        <div>
                            <span class="mob-title">Order Total</span>
                            <span>${{order.Total.toFixed(2)}}</span>
                        </div>
                        <div>
                        <span>
                            <i class="fal fa-chevron-down"></i>
                        </span>
                        </div>
                    </div>
                    <b-collapse :id="'accordion' + index" role="tabpanel" class="accordian-content">
                        <div class="item-container">
                            <div class="item-title">
                                <div class="item-name">
                                    Item Description
                                </div>
                                <div class="item-price">
                                    Each price
                                </div>
                                <div class="item-quantity">
                                    Quantity
                                </div>
                                <div class="item-total">
                                    Total
                                </div>
                            </div>
                            <div class="item-card" v-for="(item, index) in order.Items" :key="'item' + index">
                                <div class="item-name" v-if="item.Product">
                                    <span class="mob-title">Item Name</span>
                                    {{item.Product.Title}}
                                </div>
                                <div class="item-price">
                                    <span class="mob-title">Item Unit Price</span>
                                    ${{item.UnitPrice.toFixed(2)}}
                                </div>
                                <div class="item-quantity">
                                    <span class="mob-title">Quantity</span>
                                    {{item.Quantity}}
                                </div>
                                <div class="item-total">
                                    <span class="mob-title">Total</span>
                                    ${{item.Total.toFixed(2)}}
                                </div>
                            </div>
                        </div>

                        <div class="item-footer">
                            <div>
                                <span>Subtotal:</span>
                                <span>${{order.SubTotal.toFixed(2)}}</span>
                            </div>
                            <div v-for="(mod, index) in order.Modifiers" v-if="mod.Amount !== 0">
                                <span>{{mod.Title}}</span>
                                <span>${{mod.Amount.toFixed(2)}}</span>
                            </div>
                            <div>
                                <span>Total:</span>
                                <span>${{order.Total.toFixed(2)}}</span>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "OrderHistory",
        data() {
            return {}
        },
        computed: {
            ...mapGetters(['getOrderHistory']),
        },
        methods: {
            ...mapActions(['fetchOrderHistory']),
        },
        created() {
            this.fetchOrderHistory();
        }
    }
</script>

